import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../diccionarios/empModulo';

@Injectable({
  providedIn: 'root'
})
export class SeleccionCargasService {

  diccionarioUrl: any;
  urlNomina: string;
  diccionarioUrl_pe: any;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlNomina = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.seleccion;
  }

  //Carga de campeones de compromiso
  cargaCsvCampeones(formData: FormData, params:string){
    let url = this.urlNomina + this.diccionarioUrl.csvCampeones+params;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCargaCsvCampeones(payLoad: any){
    let url = this.urlNomina + this.diccionarioUrl.saveCampeones;
    return this.commom.peticionPostConHeader(url, payLoad);
  }

  //Carga de entrevistas de salida
  cargaCsvESalidas(formData: FormData, params:string){
    let url = this.urlNomina + this.diccionarioUrl.csvEntrevistaSalidas+params;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCargaCsvESalidas(payLoad: any){
    let url = this.urlNomina + this.diccionarioUrl.saveEntrevistaSalidas;
    return this.commom.peticionPostConHeader(url, payLoad);
  }

  //Carga de seleccion procesos
  cargaCsvProcesos(formData: FormData, params:string){
    let url = this.urlNomina + this.diccionarioUrl.csvSeleccionProcesos+params;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCargaCsvProcesos(payLoad: any){
    let url = this.urlNomina + this.diccionarioUrl.saveSeleccionProcesos;
    return this.commom.peticionPostConHeader(url, payLoad);
  }

  //Carga de seleccion promocion
  cargaCsvPromocion(formData: FormData, params:string){
    let url = this.urlNomina + this.diccionarioUrl.csvSeleccionPromocion+params;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCargaCsvPromocion(payLoad: any){
    let url = this.urlNomina + this.diccionarioUrl.saveSeleccionPromocion;
    return this.commom.peticionPostConHeader(url, payLoad);
  }

  // Catalogos
  cargaCsvCatalogos(formData: FormData, params:string){
    let url = this.urlNomina + this.diccionarioUrl.csvSeleccionCatalogos+params;
    return this.commom.peticionPostConHeader(url, formData);
  }

  saveCargaCsvCatalogos(payLoad: any){
    let url = this.urlNomina + this.diccionarioUrl.saveSeleccionCatalogos;
    return this.commom.peticionPostConHeader(url, payLoad);
  }

}
